import React from 'react';

const Isobanner = ({ textos }) => {
  return (
    <div className='iso-banner-main-container'>
        <div className="iso-banner">
            <img src="../assets/img/us/iso.png" alt="" />
            <div className="text-wrapper-iso">

            <h4> contamos con </h4>
            <span>CERTIFICACIÓN ISO 9001</span>

            </div>
            <img src="../assets/img/us/iso.png" alt="" />
        </div>

    </div>
  );
};

export default Isobanner;